import { getArgsAsTypesafeObjectProperties } from "../ducks/constants-util";

export const constants = getArgsAsTypesafeObjectProperties(
  "SnackbarClear",
  "SnackbarSuccess",
  "SnackbarError",
  "SnackbarWarning",
  "SnackbarInfo"
);
